import { Link } from "react-router-dom";
import { Phone, AlertTriangle } from "lucide-react";
import { FadeIn, MaskedLineScroll } from "@/components/Reveal";

export default function Urgence() {
  return (
    <section className="bg-signal text-white py-24 md:py-32 grain relative overflow-hidden" data-testid="urgence-section">
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-8">
          <FadeIn>
            <p className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-white/70">
              <AlertTriangle size={16} strokeWidth={1.5} />
              Dépannage toiture — Val-de-Marne
            </p>
          </FadeIn>
          <h2 className="mt-6 font-display font-black uppercase tracking-tighter leading-[0.95] text-3xl sm:text-4xl lg:text-5xl" data-testid="urgence-title">
            <MaskedLineScroll>Fuite de toiture ?</MaskedLineScroll>
            <MaskedLineScroll delay={0.12}>N'attendez pas que les</MaskedLineScroll>
            <MaskedLineScroll delay={0.24}>dégâts s'aggravent.</MaskedLineScroll>
          </h2>
          <FadeIn delay={0.3}>
            <p className="mt-8 text-base md:text-lg text-white/85 leading-relaxed max-w-2xl">
              Une trace d'humidité au plafond, une tache qui s'étend, un goutte-à-goutte les jours de pluie :
              une infiltration d'eau ne se répare jamais toute seule. MSC Toitures intervient dans tout le
              Val-de-Marne pour identifier l'origine exacte des infiltrations — tuile cassée, zinguerie
                  défaillante, problème d'étanchéité — et effectuer les réparations nécessaires avant que
              l'eau n'attaque la charpente et l'isolation.
            </p>
          </FadeIn>
        </div>
        <div className="lg:col-span-4 flex flex-col gap-4">
          <FadeIn delay={0.35}>
            <a
              href="tel:0646300391"
              data-testid="urgence-call-button"
              className="btn-sweep flex items-center justify-center gap-3 bg-midnight text-white font-display font-bold text-lg uppercase tracking-wide px-8 py-5 w-full transition-colors duration-300"
            >
              <Phone size={20} strokeWidth={1.5} />
              Appeler MSC Toitures
            </a>
          </FadeIn>
          <FadeIn delay={0.45}>
            <Link
              to="/#contact"
              data-testid="urgence-quote-button"
              className="btn-sweep flex items-center justify-center border border-white/60 text-white font-display font-bold text-base uppercase tracking-wide px-8 py-4 w-full transition-colors duration-300"
            >
              Demander un devis gratuit
            </Link>
          </FadeIn>
          <FadeIn delay={0.5}>
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/60 text-center">
              06 46 30 03 91 — 01 87 07 86 62
            </p>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}
